import {
  Box, Dialog, DialogActions, DialogContent,
  DialogTitle,
  IconButton, Typography,
  Button,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import { POSITION_CLOSURE_REASON, POSITION_STATE } from '../../../consts/enums';
import STRING_KEYS from '../../../language/keys';
import { PositionClosure, PositionState } from '../../../@types/position';
import { PositionCloseDialogContent } from './PositionCloseDialogContent';
import { style } from './style';

type PositionCloseDialogProps = {
  onCloseDialog: () => void,
  onPositionStateChange: (positionState: PositionState) => void,
  isOpen: boolean,
  viewMode: ViewMode,
}
export const PositionCloseDialog = ({
  onCloseDialog,
  isOpen,
  viewMode,
  onPositionStateChange,
}: PositionCloseDialogProps):JSX.Element => {
  const { t: translate } = useTranslation();
  const formik = useFormik<{ freeText: string, closureReason: string }>({
    initialValues: {
      freeText: '',
      closureReason: POSITION_CLOSURE_REASON.POSITION_ALREADY_FULFILLED,
    },
    onSubmit: (data: PositionClosure) => {
      if (data.closureReason === POSITION_CLOSURE_REASON.OTHER) {
        onPositionStateChange({
          state: POSITION_STATE.CLOSED,
          positionClosure: {
            freeText: data.freeText,
            closureReason: data.closureReason,
          },
        });
      } else {
        onPositionStateChange({
          state: POSITION_STATE.CLOSED,
          positionClosure: {
            closureReason: data.closureReason,
          },
        });
      }
    },
  });

  const handleChangeValues = (key: string, value: string) => {
    formik.setFieldValue(key, value);
  };

  const renderContent = () => {
    return (
      <PositionCloseDialogContent
        viewMode={ viewMode }
        onChangeValues={ handleChangeValues }
        freeText={ formik.values.freeText }
        closureReason={ formik.values.closureReason }
      />
    );
  };

  return (
    <Dialog
      open={ isOpen }
      fullWidth
      onClick={ (e) => e.stopPropagation() }
    >
      <form onSubmit={ formik.handleSubmit }>
        <DialogTitle sx={ style.dialogTitle }>
          <Box sx={ style.titleBox }>
            <Typography variant={ style.titleVariant }>
              { translate(STRING_KEYS.CLOSE_POSITION_DIALOG_TITLE) }
            </Typography>
            <IconButton
              onClick={ onCloseDialog }
              sx={ style.closeIcon }
            >
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          {renderContent()}
        </DialogContent>
        <DialogActions>
          <Button variant="text" color="primary">
            {translate(STRING_KEYS.DIALOG.BTN_GO_BACK)}
          </Button>
          <Button
            variant="contained"
            color="primary"
            type="submit"
          >
            {translate(STRING_KEYS.CLOSE_POSITION_DIALOG_TITLE)}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
